import { useState, useEffect, useImperativeHandle, forwardRef } from "react"
import { Select } from "components/ui"
import { arrayOf, shape, func, number, bool } from "prop-types"
import _ from "underscore"

const SuggestedContactDropdown = forwardRef(
  (
    {
      suggestedPeople = [],
      onSelect = () => {},
      onSearch = () => {},
      selectedContact,
      disabled = false
    },
    ref
  ) => {
    const [selected, setSelected] = useState(selectedContact?.id || "search")

    useEffect(() => {
      if (selectedContact) {
        setSelected(selectedContact.account_center_id ?? selectedContact.accountCenterId)
      } else {
        setSelected("search")
      }
    }, [selectedContact])

    useImperativeHandle(ref, () => ({
      setSelection(personId) {
        setSelected(personId)
      }
    }))

    const possibleContacts = {}
    _.uniq(suggestedPeople, "accountCenterId").map(p => {
      if (!!p?.accountCenterId || !!p?.account_center_id) {
        possibleContacts[p.accountCenterId || p.account_center_id] = p
      }
    })

    const _defaultOption = {
      label: "Select a person",
      value: "select",
      key: "selectRegContact",
      hidden: true,
      disabled: true
    }

    const suggestPeopleOptions = [
      ...Object.values(possibleContacts).map(person => {
        return {
          label: person.name,
          value: person.accountCenterId ?? person.account_center_id
        }
      }),
      { label: "Someone else...", value: "search" }
    ]

    const handleContactSelection = e => {
      setSelected(e.target.value)
      if (e.target.value == "search") {
        return onSearch()
      } else {
        return onSelect(possibleContacts[e.target.value])
      }
    }

    return (
      <>
        {Object.values(possibleContacts).length >= 1 && (
          <Select
            disabled={disabled}
            name="registrationContactSelection"
            className="select"
            id="registrationContactSelection"
            options={suggestPeopleOptions}
            defaultValue={selected}
            value={selected}
            onChange={handleContactSelection}
          />
        )}
      </>
    )
  }
)

SuggestedContactDropdown.propTypes = {
  suggestedPeople: arrayOf(
    shape({
      personId: number,
      account_center_id: number,
      accountCenterId: number
    })
  ),
  onSelect: func,
  onSearch: func,
  selectedContact: shape({
    accountCenterId: number,
    account_center_id: number
  }),
  disabled: bool
}

export default SuggestedContactDropdown
